module.exports = __webpack_public_path__ + "static/logoorange-4e3ee641d83eb235938a5412be37783a.svg";